import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-869ebbb2")

_pushScopeId("data-v-869ebbb2")
const _hoisted_1 = {
  key: 0,
  class: "field mb-5"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Template name*", -1)
const _hoisted_3 = { class: "control" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Working", -1)
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "checkbox" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Remote ")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "label mt-4" }, "Comment", -1)
const _hoisted_10 = { class: "is-flex is-justify-content-flex-end mt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_periods_picker = _resolveComponent("periods-picker")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("form", {
    class: "wrap box",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    (_ctx.withTemplateName)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _withDirectives(_createVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.templateName = $event)),
              type: "text",
              placeholder: "Default day",
              required: "",
              minlength: "3",
              maxlength: "255"
            }, null, 512), [
              [_vModelText, _ctx.templateName]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("label", _hoisted_6, [
        _withDirectives(_createVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.remote = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.remote]
        ]),
        _hoisted_7
      ])
    ]),
    _createVNode(_component_periods_picker, {
      modelValue: _ctx.periods,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.periods = $event))
    }, null, 8, ["modelValue"]),
    (!_ctx.withTemplateName)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createVNode("textarea", {
            class: "textarea",
            placeholder: "e.g. Idę z psem na spacer o 16",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.comment = $event))
          }, null, 512), [
            [_vModelText, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_10, [
      (_ctx.cancelText)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "button mr-4 is-outlined is-danger",
            to: "/my-templates"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode("button", {
        class: ["button is-success is-outlined", { 'is-loading': _ctx.isSubmitLoading }],
        type: "submit"
      }, _toDisplayString(_ctx.submitText), 3)
    ])
  ], 32))
})